<template>
  <div style="margin: 0; padding: 0">
    <div
      v-if="
        restaurant && restaurant.id && restaurant.settings && restaurant.settings.header
      "
      class="hero"
      :style="`background: url('https://app.restorani.bitlab.host/gallery/${restaurant.id}/medium/${restaurant.settings.header}'); background-size: cover;width:100vw background-position: center;`"
    >
      <img
        class="hero-logo"
        :src="
          conf.apiUrlBase + '/gallery/' + restaurant.id + '/' + restaurant.settings.logo
        "
      />
    </div>

    <page-header
      icon="mdi-map-marker-radius"
      :title="toLatin(user.name) + ' ' + toLatin(user.lastname)"
      :subtitle="$t('change_location_title')"
    />

    <v-container style="max-width: 1170px">
      <v-row justify="center  ">
        <v-col lg="4" md="4" sm="12" xs="12" cols="12">
          <span class="izaberi-datum">{{ $t("choose_date") }}</span>
          <v-date-picker
            v-model="date"
            :min="new Date().toISOString().substr(0, 10)"
            no-title
            scrollable
            @input="reqOrder()"
          >
          </v-date-picker>
        </v-col>

        <v-col lg="4" md="4" sm="12" xs="12" cols="12">
          <div class="lista-narucenih-stvari" v-if="this.orders.length">
            <span>{{ $t("food_ordered") }}</span>

            <ul>
              <li v-for="order in orders" @click="openDialog(order)">
                <v-icon class="ikonica">mdi-food-fork-drink</v-icon>
                {{ translate(order.meals.name) }} ({{ order.quantity }})
              </li>
            </ul>
          </div>

          <div v-else>
            <v-btn text small @click="$router.push({ name: 'company-menu' })">
              {{ $t("no_orders_for_selected_date") }}</v-btn
            >
            <v-btn
              class="mt-2"
              color="error darken-1"
              dark
              small
              @click="$router.push({ name: 'company-menu' })"
            >
              {{ $t("do_order") }}
            </v-btn>
          </div>
        </v-col>

        <v-col lg="4" md="4" sm="12" xs="12" cols="12" v-if="this.orders.length">
          <span class="promjena-lokacije">
            {{ $t("locations_change") }}
          </span>

          <v-card-text>
            <autocomplete
              v-model="location"
              :items="companies"
              :label="$t('office_for_delivery')"
              @change="selectCompany"
              item-text="1"
              item-value="0"
              return-object
              icon="mdi-store"
            >
            </autocomplete>
          </v-card-text>

          <v-card-text>
            <shift-picker
              v-model="shift"
              :label="$t('shift_you_work')"
              return-object
              :items="shifts"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <primary-button @click="change()">
              {{ $t("change") }}
            </primary-button>
          </v-card-actions>
          <!-- </v-card> -->
        </v-col>

        <v-col v-else lg="4" md="4" sm="12" xs="12" cols="12"> </v-col>
      </v-row>
      <global-dialog-card v-model="dialog" max-width="800px" title="" hide-actions>
        <v-row>
          <v-col cols="12" sm="6">
            <v-img
              :src="
                selectedMeal.image
                  ? conf.apiUrlBase +
                    '/gallery/' +
                    restaurant +
                    '/medium/' +
                    selectedMeal.image.name
                  : './media/img/no-image.webp'
              "
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col cols="12" sm="6" class="ml-sm-n16 my-sm-2 mt-sm-16">
            <v-row align="end" class="fill-height">
              <v-card elevation="0" class="pa-5">
                <v-card-title>
                  <h3>
                    {{ toLatin(selectedMeal.meals.name) }}
                  </h3>
                </v-card-title>

                <v-card-text class="mb-4">
                  <v-row no-gutters>
                    <template v-for="(eat, i) in selectedMeal.meals.foods">
                      <v-col cols="12" class="font-weight-bold pt-2">
                        <v-row no-gutters justify="space-between">
                          <span
                            ><h3>{{ translate(eat.name) }}</h3></span
                          >
                        </v-row>
                      </v-col>
                      <v-col cols="12">{{ translate(eat.description) }}</v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </global-dialog-card>
    </v-container>
  </div>
</template>

<script>
import conf from "@/config";
import companyService from "@/services/company";
import orderService from "@/services/order";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  mixins: [hasSnackbar],
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    conf: conf,
    dialog: false,
    selectedMeal: { meals: { name: null, foods: {} } },
    shift: null,
    shifts: [],
    cId: 0,
    orders: [],
    companies: [],
    location: null,
  }),

  computed: {
    restaurant() {
      return this.$store.state.restaurant
        ? this.$store.state.restaurant
        : this.$store.state.company.restaurant;
    },
    user() {
      return this.$store.state.user.user || {};
    },
  },

  watch: {},

  created() {
    this.initialize();
    this.reqOrder();
  },

  methods: {
    async selectCompany() {
      try {
        this.shifts = [];
        const res = await companyService.getCompanyById(this.location[0]);
        if (res.data.shift_one) {
          this.shifts.push({ id: 1, text: "Прва" });
        }
        if (res.data.shift_two) {
          this.shifts.push({ id: 2, text: "Друга" });
        }
        if (res.data.shift_three) {
          this.shifts.push({ id: 3, text: "Трећа" });
        }
        this.shift = this.shifts[0];
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_company"));
      }
    },
    async initialize() {
      try {
        this.cId = this.$store.state.company.parent_id;
        if (!this.cId) this.cId = this.$store.state.company.id;
        const res = await companyService.getCompanyList(this.cId);
        this.companies = res.data;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_companies"));
      }
    },
    openDialog(item) {
      this.dialog = true;
      this.selectedMeal = item;
    },
    async reqOrder() {
      try {
        this.orders = [];
        if (this.date) {
          const res = await orderService.getOrdersByUserId(this.user.id, this.date);
          this.orders = res.data;
          if (this.orders.length) {
            this.location = this.companies.find((o) => o[0] == this.orders[0].company_id);
            const companyRes = await companyService.getCompanyById(this.location[0]);
            if (companyRes.data.shift_one) {
              this.shifts.push({ id: 1, text: "Прва" });
              if (this.orders[0].shift == "1-smena") this.shift = { id: 1, text: "Прва" };
            }
            if (companyRes.data.shift_two) {
              this.shifts.push({ id: 2, text: "Друга" });
              if (this.orders[0].shift == "2-smena")
                this.shift = { id: 2, text: "Друга" };
            }
            if (companyRes.data.shift_three) {
              this.shifts.push({ id: 3, text: "Трећа" });
              if (this.orders[0].shift == "3-smena")
                this.shift = { id: 3, text: "Трећа" };
            }
          }
        }
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_orders"));
      }
    },
    async change() {
      try {
        if (this.location[0] && this.shift.id) {
          await orderService.changeOrderLocation({
            userId: this.user.id,
            date: this.date,
            location: this.location[0],
            shift: this.shift.id,
            _method: "patch",
          });
          this.location = [];
          this.shift = [];
          this.showSuccessSnackbar(this.$t("location_changed_successfully"));
        } else {
          this.showErrorSnackbar(this.$t("please_select_location_and_shift"));
        }
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_changing_location"));
      }
    },
  },
};
</script>

<style scoped>
.lista-narucenih-stvari span,
.izaberi-datum,
.promjena-lokacije {
  font-size: 20px;
  line-height: 2rem;
  font-family: "Roboto", sans-serif !important;
  padding: 8px 15px;
  background: #e0e0e0;
  display: block;
  margin-bottom: 15px;
}

.lista-narucenih-stvari ul {
  margin-top: 20px;
  list-style: none;
  padding: 0;
  margin: 0;
  display: block;
}

.lista-narucenih-stvari ul li {
  font-size: 19px;
  color: rgba(0, 0, 0, 0.87);
  padding: 15px 10px;
  cursor: pointer;
}

.lista-narucenih-stvari ul li:hover {
  background: #ededed;
}

.lista-narucenih-stvari ul li:nth-child(even) {
  background: #f3f4f4;
}

.ikonica {
  margin-top: -5px;
}
</style>
